// TODO: Add clustering
import HeartIcon from "../../../images/marker/SuitHearts.svg";
import MultipleMarkerIcon from "../../../images/marker/marker-multiple-incidents.svg";

export class BaseLayer {
  constructor(map, apiUrl, exportUrl, csrfToken) {
    // eslint-disable-next-line no-undef
    this.layer = new google.maps.Data();
    this.map = map;
    this.apiUrl = apiUrl;
    this.exportUrl = exportUrl;
    this.csrfToken = csrfToken;
    this.markerStorage = [];
    this.visibleMarkers = [];
    this.layerName = "BaseLayer";
    this.exportName = "BaseLayer";
  }

  create() {
    this.fetchPointsFromApi();

    const sizeHeight = 48;
    const sizeWidth = 48;

    this.layer.setStyle((feature) => {
      let title = this.markerTitle;
      let pathToMarkerIcon = feature.getProperty("markerIcon");

      if (feature.getProperty("at_same_location_count") > 1) {
        pathToMarkerIcon = MultipleMarkerIcon;
        title = "Multiple Incidents";
      }

      const markerIcon = {
        url: pathToMarkerIcon === undefined || pathToMarkerIcon === "" ? HeartIcon : pathToMarkerIcon,
        /* eslint-disable no-undef */
        scaledSize: new google.maps.Size(sizeWidth, sizeHeight),
        size: new google.maps.Size(sizeWidth, sizeHeight),
        /* eslint-enable no-undef */
      };

      const markerZIndex = Number(feature.getProperty("marker_z_index")) || 0;

      return { icon: markerIcon, title: title, zIndex: markerZIndex };
    });

    const layerActivationState = localStorage.getItem(this.layerName);
    if (layerActivationState === "enabled") {
      this.enable();
    } else if (layerActivationState === "disabled") {
      this.disable();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.toggleButton.addEventListener("click", (event) => {
      event.preventDefault();
      if (event.currentTarget.classList.contains("active")) {
        this.disable(event);
      } else {
        this.enable(event);
      }
    });

    const self = this;
    this.layer.addListener("click", function (event) {
      self.showInfoWindow(event);
    });

    // eslint-disable-next-line no-unused-vars
    window.addEventListener("limitRadiusHasChecked", (event) => {
      document.querySelector("input[name=radius]:checked").dispatchEvent(new Event("change"));
    });

    window.addEventListener("limitRadiusHasUnchecked", () => {
      this.visibleMarkers = [];
      this.setFeatures(this.markerStorage);
    });

    window.addEventListener("radiusHasChanged", (event) => {
      this.hideOutOfRangeMarkers(event);
    });

    window.addEventListener("exportMarkersAtRoute", (event) => {
      this.exportMarkers(event);
    });

    window.addEventListener("reloadData", (event) => {
      if (event.detail.layerName === this.layerName) {
        this.fetchPointsFromApi();
      }
    });
  }

  fetchPointsFromApi() {
    window.dispatchEvent(new CustomEvent("oneMoreMapItemLoading", {}));
    fetch(this.apiUrl, {})
      .then((response) => {
        response.json().then((geoJson) => {
          let enable = false;
          //* hide the layer while redrawing the objects. addGeoJson() will put the objects onto map directly,
          //* but we may want to limit them to the route. if we don't hide the layer, objects would appear and then disappear,
          //* which is not a good UX
          if (this.isEnabled()) {
            this.layer.setMap(null);
            enable = true;
          }
          this.removeFeatures();
          this.markerStorage = this.layer.addGeoJson(geoJson);
          if (document.querySelector("input[name=limitRadius]").checked) {
            this.hideOutOfRangeMarkers();
          }
          if (enable) {
            this.layer.setMap(this.map);
          }
        });
      })
      .catch((reason) => console.error(reason))
      .finally(() => window.dispatchEvent(new CustomEvent("oneLessMapItemLoading", {})));
  }

  enable() {
    this.toggleButton.classList.add("active");
    this.layer.setMap(this.map);
    localStorage.setItem(this.layerName, "enabled");
    window.dispatchEvent(new Event(this.layerName + "_enabled"));
  }

  disable() {
    this.toggleButton.classList.remove("active");
    this.layer.setMap(null);
    localStorage.setItem(this.layerName, "disabled");
    window.dispatchEvent(new Event(this.layerName + "_disabled"));
  }

  show() {
    this.layer.setMap(this.map);
    window.dispatchEvent(new Event(this.layerName + "_show"));
  }

  hide() {
    this.layer.setMap(null);
    window.dispatchEvent(new Event(this.layerName + "_hide"));
  }

  isVisible() {
    return this.layer.getMap() !== null && this.toggleButton.classList.contains("active");
  }

  isHidden() {
    return this.layer.getMap() === null && this.toggleButton.classList.contains("active");
  }

  isEnabled() {
    return this.layer.getMap() !== null && this.toggleButton.classList.contains("active");
  }

  isDisabled() {
    return this.layer.getMap() === null && this.toggleButton.classList.contains("active") === false;
  }

  createInfoWindow(listItems, event, showMoreLink = true) {
    const feature = event.feature;

    if (feature.getProperty("infoBox") === "open") {
      return;
    }

    // Create the card
    const card = document.createElement("div");
    card.classList.add("card");
    card.style.border = "none";

    // Create the card header
    const cardHeader = document.createElement("div");
    cardHeader.classList.add("card-header", "text-white", "bg-secondary");
    cardHeader.innerText = this.markerTitle;

    // Create the card body
    const cardBody = document.createElement("div");
    cardHeader.classList.add("card-body");

    // Create the card title
    const cardTitle = document.createElement("div");
    cardTitle.classList.add("card-title");
    cardTitle.innerText = "";

    // Create the card text
    const cardBodyText = document.createElement("div");
    cardBodyText.classList.add("card-text");
    cardBodyText.style.lineHeight = "1.4";

    card.appendChild(cardHeader);
    card.appendChild(cardTitle);
    card.appendChild(cardBody);
    cardBody.appendChild(cardBodyText);

    const ul = document.createElement("ul");
    ul.classList.add("fa-ul");

    listItems.forEach((item) => {
      const li = document.createElement("li");
      li.innerHTML = item;
      ul.append(li);
    });

    cardBodyText.appendChild(ul);

    const companyLogo = feature.getProperty("companyLogo");
    if (companyLogo !== undefined && companyLogo !== "") {
      const image = document.createElement("img");
      image.src = companyLogo;
      image.height = 100;
      image.classList = "company-logo";
      cardBodyText.appendChild(image);
    }

    if (showMoreLink) {
      let href;
      const constructorName = this.layerName;

      if (constructorName.search("Incident") > -1) {
        href = "/incident/view?id=" + feature.getId();
      } else if (constructorName.search("ParkingSpot") > -1) {
        href = "/psr-location/view?id=" + feature.getId();
      } else if (constructorName.search("TsrLocations") > -1) {
        href = "/tsr-location/view?id=" + feature.getId();
      } else if (constructorName.search("FsrLocations") > -1) {
        href = "/fsr-location/view?id=" + feature.getId();
      }

      const bfs = feature.getProperty("booking_platforms");
      if (Array.isArray(bfs) && bfs.length > 0) {
        const paragraph = document.createElement("p");
        paragraph.innerText = "Booking Platform(s):";
        paragraph.classList.add("markerLinkHeader");
        cardBody.appendChild(paragraph);
        for (const bf of bfs) {
          const alt = `Booking Platform ${bf.name}`;
          const bfLink = document.createElement("a");
          bfLink.href = bf.url;
          bfLink.style.textDecoration = "underline";
          bfLink.style.display = "block";
          bfLink.target = "_blank";
          bfLink.rel = "nofollow";
          bfLink.title = alt;

          if (bf.image) {
            const bfImage = document.createElement("img");
            bfImage.src = bf.image;
            bfLink.alt = alt;
            bfLink.title = alt;
            bfImage.classList.add("psr-booking-platform-image");
            bfLink.appendChild(bfImage);
          } else {
            bfLink.innerText = bf.name;
          }

          bfLink.classList.add("markerLink");
          cardBody.appendChild(bfLink);
        }
        cardBody.appendChild(document.createElement("br"));
      }

      const moreLink = document.createElement("a");
      moreLink.innerText = "More details";
      moreLink.style.textDecoration = "underline";
      moreLink.dataset.toggle = "modal";
      moreLink.dataset.target = "#detailModal";
      moreLink.dataset.href = href;
      moreLink.dataset.key = feature.getId();
      moreLink.classList.add("markerPopupButton");

      cardBody.appendChild(moreLink);
    }

    /* eslint-disable no-undef */
    const infoWindow = new google.maps.InfoWindow();
    infoWindow.setContent(card);
    infoWindow.setPosition(feature.getGeometry().get());
    infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -30) });
    infoWindow.open(this.map);
    feature.setProperty("infoBox", "open");
    window.addEventListener(this.layerName + "_disabled", () => {
      infoWindow.close();
      this.markerStorage.forEach((feature) => {
        feature.setProperty("infoBox", "closed");
      });
    });

    infoWindow.addListener("closeclick", () => {
      feature.setProperty("infoBox", "closed");
    });

    infoWindow.addListener("domready", () => {
      const closeButtons = document.querySelectorAll('button[title="Close"]');
      closeButtons.forEach((button) => {
        if (button) {
          button.style.top = 0;
          button.style.right = 0;
          const image = button.querySelector("img");
          if (image) {
            button.removeChild(image);
            const span = document.createElement("span");
            span.classList.add("text-white");
            span.textContent = "x";
            button.appendChild(span);
          }
        }
      });
    });
    /* eslint-enable no-undef */
  }

  hideOutOfRangeMarkers() {
    const radius = document.querySelector("input[name=radius]:checked").value * 1000;
    const route = window.directionsRenderer.getDirections();
    this.visibleMarkers = [];
    if (route) {
      this.markerStorage.forEach((feature) => {
        for (let point of route.routes[window.directionsRenderer.routeIndex].overview_path) {
          // eslint-disable-next-line no-undef
          const distance = google.maps.geometry.spherical.computeDistanceBetween(feature.getGeometry().get(), point);
          if (distance <= radius) {
            this.visibleMarkers.push(feature);
            // Leave the inner loop here, when the feature is within the radius.
            // There is no need to compare the other points.
            break;
          }
        }
      });
      this.setFeatures(this.visibleMarkers);
    }
  }

  exportMarkers() {
    if (this.isEnabled() && this.visibleMarkers.length) {
      const timestamp = new Date().toJSON().slice(0, 10).replace(/-/g, "").substr(2);
      const filename = `${this.exportName}_${document.getElementById("startingPoint").value}_${
        document.getElementById("destination").value
      }_${timestamp}.csv`
        .replaceAll(/[^\p{Letter}0-9_.]/gu, "_")
        .replaceAll(/[_]{2,}/g, "_");
      const ids = this.visibleMarkers.map((f) => f.getId());
      fetch(this.exportUrl, {
        method: "POST",
        body: new URLSearchParams({ ids }),
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-Token": this.csrfToken,
        },
      })
        .then((t) =>
          t.blob().then((b) => {
            const a = document.createElement("a");
            a.href = URL.createObjectURL(b);
            a.setAttribute("download", filename);
            a.click();
          })
        )
        .catch();
    }
  }

  removeFeatures() {
    this.markerStorage.forEach((feature) => {
      this.layer.remove(feature);
    });
  }

  setFeatures(features) {
    this.removeFeatures();
    features.forEach((feature) => {
      this.layer.add(feature);
    });
  }
}
